import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/PremiumPlaceholders.css';

// Groups Placeholder
export const GroupsPlaceholder = ({ onUpgrade }) => {
  const { t } = useLanguage();
  
  return (
    <div className="premium-placeholder">
      <div className="placeholder-header">
        <h2>👥 {t('groups') || 'Gruppen'}</h2>
        <span className="premium-badge-large">🧪 Beta</span>
      </div>
      
      <div className="placeholder-content">
        <div className="feature-preview">
          <div className="preview-item">
            <span className="preview-icon">👨‍👩‍👧‍👦</span>
            <span className="preview-text">Familie (5 Mitglieder)</span>
          </div>
          <div className="preview-item">
            <span className="preview-icon">💼</span>
            <span className="preview-text">Arbeit (12 Kollegen)</span>
          </div>
          <div className="preview-item">
            <span className="preview-icon">🎓</span>
            <span className="preview-text">Studium (8 Kommilitonen)</span>
          </div>
        </div>
        
        <div className="placeholder-description">
          <h3>Teile Bookmarks mit Freunden & Familie</h3>
          <ul>
            <li>✅ Unbegrenzte Gruppen erstellen</li>
            <li>✅ Mitglieder per E-Mail einladen</li>
            <li>✅ Gruppen-Chat für Diskussionen</li>
            <li>✅ Gemeinsame Kategorisierung</li>
            <li>✅ Admin-Rechte verwalten</li>
          </ul>
        </div>
        
        <button className="upgrade-button" onClick={onUpgrade}>
          🧪 Beta testen
        </button>
      </div>
    </div>
  );
};

// Reminders Placeholder
export const RemindersPlaceholder = ({ onUpgrade }) => {
  const { t } = useLanguage();
  
  return (
    <div className="premium-placeholder">
      <div className="placeholder-header">
        <h2>⏰ {t('reminders') || 'Reminder'}</h2>
        <span className="premium-badge-large">🧪 Beta</span>
      </div>
      
      <div className="placeholder-content">
        <div className="feature-preview">
          <div className="preview-item">
            <span className="preview-icon">📚</span>
            <span className="preview-text">Täglich 09:00 - Lernen fortsetzen</span>
          </div>
          <div className="preview-item">
            <span className="preview-icon">🍳</span>
            <span className="preview-text">Mo,Mi,Fr 18:00 - Rezepte checken</span>
          </div>
          <div className="preview-item">
            <span className="preview-icon">💼</span>
            <span className="preview-text">Wöchentlich - Projektdokumentation</span>
          </div>
        </div>
        
        <div className="placeholder-description">
          <h3>Verpasse nie wieder wichtige Bookmarks</h3>
          <ul>
            <li>✅ Smart Reminders basierend auf Content</li>
            <li>✅ Push-Notifications & E-Mail-Alerts</li>
            <li>✅ Wiederkehrende Termine</li>
            <li>✅ Kontext-basierte Erinnerungen</li>
            <li>✅ Snooze & Quick Actions</li>
          </ul>
        </div>
        
        <button className="upgrade-button" onClick={onUpgrade}>
          🧪 Beta testen
        </button>
      </div>
    </div>
  );
};

// AI Assistant Placeholder
export const AIAssistantPlaceholder = ({ onUpgrade }) => {
  const { t } = useLanguage();
  
  return (
    <div className="premium-placeholder">
      <div className="placeholder-header">
        <div className="ai-header">
          <h2>🤖 {t('aiAssistant') || 'KI-Assistent'}</h2>
          <button 
            className="microphone-btn"
            title="Sprachsteuerung aktivieren"
            onClick={() => console.log('Voice control activated')}
          >
            🎤
          </button>
        </div>
        <span className="premium-badge-large">🧪 Beta</span>
      </div>
      
      <div className="placeholder-content">
        <div className="feature-preview">
          <div className="ai-chat-preview">
            <div className="chat-message user">
              🎤 "Was kann ich heute mit Tomaten kochen?"
            </div>
            <div className="chat-message ai">
              👨‍🍳 Basierend auf deinen 23 Rezept-Bookmarks empfehle ich:
              <br />🍝 Pasta Arrabiata
              <br />🥗 Caprese Salat  
              <br />🍕 Margherita Pizza
            </div>
          </div>
        </div>
        
        <div className="placeholder-description">
          <h3>Intelligente Rezept-Empfehlungen per Sprache</h3>
          <ul>
            <li>✅ Spracheingabe für Bookmark-Suche</li>
            <li>✅ KI-Rezept-Kreationen aus deinen Links</li>
            <li>✅ Smart Recommendations</li>
            <li>✅ Meal-Planning Integration</li>
            <li>✅ Einkaufslisten generieren</li>
          </ul>
        </div>
        
        <button className="upgrade-button" onClick={onUpgrade}>
          🧪 Beta testen
        </button>
      </div>
    </div>
  );
};

// Upgrade Prompt Modal
export const UpgradeModal = ({ isOpen, onClose, feature }) => {
  if (!isOpen) return null;
  
  return (
    <div className="upgrade-modal-overlay" onClick={onClose}>
      <div className="upgrade-modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        
        <div className="modal-header">
          <h2>🧪 Beta upgraden</h2>
          <p>Schalte {feature} und alle Beta-Features frei!</p>
        </div>
        
        <div className="pricing-cards">
          <div className="pricing-card">
            <div className="plan-name">Beta</div>
            <div className="plan-price">€4.99<span>/Monat</span></div>
            <div className="plan-features">
              <div className="feature">✅ Unbegrenzte Gruppen</div>
              <div className="feature">✅ Smart Reminders</div>
              <div className="feature">✅ Cloud Backup</div>
              <div className="feature">✅ Analytics Dashboard</div>
              <div className="feature">✅ KI-Assistent</div>
            </div>
            <button className="select-plan-button">
              🧪 Beta wählen
            </button>
          </div>
          
          <div className="pricing-card pro">
            <div className="plan-badge">Beliebt</div>
            <div className="plan-name">Pro</div>
            <div className="plan-price">€9.99<span>/Monat</span></div>
            <div className="plan-features">
              <div className="feature">✅ Alles aus Beta</div>
              <div className="feature">✅ Team-Management</div>
              <div className="feature">✅ Advanced Analytics</div>
              <div className="feature">✅ API Access</div>
              <div className="feature">✅ Priority Support</div>
            </div>
            <button className="select-plan-button pro">
              👑 Pro wählen
            </button>
          </div>
        </div>
        
        <div className="modal-footer">
          <p>🔒 Sicher bezahlen mit Stripe • 30 Tage Geld-zurück-Garantie</p>
        </div>
      </div>
    </div>
  );
};